export const createAdConfig = (
  unitCode,
  size,
  slotId,
  targetingCategory,
  sticky,
  targetPlatform,
  hasParent = false
) => {
  const res = {
    unitCode: `/284705699/Onebox/${unitCode}`,
    size,
    slotId,
    apstag: true,
    targeting: { category: targetingCategory },
    targetPlatform
  }
  if (sticky) {
    res.sticky = true
  }
  if (hasParent) {
    res.hasParent = true
  }
  return res
}
